(function () {
  var DEFAULT_ENDPOINT = "https://api.deepdivesupplements.com/dispute/";
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ALLOWED_REASONS = [
    "I want to dispute a subscription or recurring payment",
    "I do not recognize this charge",
    "I have cancelled this order already",
    "I am not satisfied with my product",
    "I received an item that is different or not as described",
    "I have not received my product",
    "The delivery is taking too long / not progressing",
    "I have already returned this product",
    "I am waiting on my refund",
  ];
  var globalClickBound = false;

  function init(root) {
    if (!root || root.getAttribute("data-dd-init") === "1") return;
    root.setAttribute("data-dd-init", "1");

    var ENDPOINT = root.getAttribute("data-endpoint") || DEFAULT_ENDPOINT;

    var stepper = root.querySelector("#disputeStepper");
    var stepEls = {
      1: root.querySelector("#disputeStep1"),
      2: root.querySelector("#disputeStep2"),
      3: root.querySelector("#disputeStep3"),
    };
    var form = root.querySelector("#disputeForm");
    var submitBtn = root.querySelector("#disputeSubmit");
    var notice = root.querySelector("#disputeNotice");
    if (!stepper || !form || !submitBtn || !notice) return;
    var submitLabel = submitBtn.querySelector(".dispute-btn__label");

    var fields = {
      contactReason: root.querySelector("#disputeReason"),
      phone: root.querySelector("#disputePhone"),
      orderNumber: root.querySelector("#disputeOrder"),
      amount: root.querySelector("#disputeAmount"),
      paymentMethod: root.querySelector("#disputePayment"),
      email: root.querySelector("#disputeEmail"),
      message: root.querySelector("#disputeMessage"),
      firstName: root.querySelector("#disputeFirstName"),
    };

    function goToStep(n) {
      for (var k in stepEls) {
        if (stepEls[k]) stepEls[k].hidden = Number(k) !== n;
      }
      stepper.setAttribute("data-step", String(n));
      var items = stepper.querySelectorAll(".dispute-stepper__item");
      for (var i = 0; i < items.length; i++) {
        var s = Number(items[i].getAttribute("data-step-item"));
        items[i].classList.toggle("is-complete", s < n);
        items[i].classList.toggle("is-active", s === n);
      }
      if (stepEls[n]) {
        stepEls[n].style.animation = "none";
        void stepEls[n].offsetWidth;
        stepEls[n].style.animation = "";
      }
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }

    var stepButtons = root.querySelectorAll("[data-go-step]");
    for (var i = 0; i < stepButtons.length; i++) {
      stepButtons[i].addEventListener("click", function (ev) {
        var target = Number(ev.currentTarget.getAttribute("data-go-step"));
        if (target) goToStep(target);
      });
    }

    function setInvalid(el, invalid) {
      var field = el.closest(".dispute-field");
      if (field) field.classList.toggle("is-invalid", invalid);
    }

    for (var key in fields) {
      (function (el) {
        if (!el) return;
        var ev = el.tagName === "SELECT" ? "change" : "input";
        el.addEventListener(ev, function () {
          setInvalid(el, false);
          clearNotice();
        });
      })(fields[key]);
    }

    function showNotice(kind, msg) {
      notice.className =
        "dispute-notice dispute-notice--" + kind + " is-visible";
      notice.textContent = msg;
    }
    function clearNotice() {
      notice.className = "dispute-notice";
      notice.textContent = "";
    }
    function setSending(sending) {
      submitBtn.disabled = sending;
      submitBtn.classList.toggle("is-loading", sending);
      submitLabel.textContent = sending ? "Submitting…" : "Start Dispute";
    }

    function validate() {
      var v = {
        contactReason: fields.contactReason.value,
        phone: fields.phone.value.trim(),
        orderNumber: fields.orderNumber.value.trim(),
        amount: fields.amount.value.trim(),
        paymentMethod: fields.paymentMethod.value.trim(),
        email: fields.email.value.trim(),
        message: fields.message.value.trim(),
        firstName: fields.firstName.value.trim(),
      };
      var errors = {};
      if (
        !v.contactReason ||
        ALLOWED_REASONS.indexOf(v.contactReason) === -1
      ) {
        errors.contactReason = true;
      }
      var phoneDigits = v.phone.replace(/\D/g, "");
      if (phoneDigits.length < 7 || v.phone.length > 20) errors.phone = true;
      if (!v.orderNumber || v.orderNumber.length > 50)
        errors.orderNumber = true;
      var amt = parseFloat(v.amount);
      if (isNaN(amt) || amt <= 0 || amt > 100000) errors.amount = true;
      if (!v.paymentMethod || v.paymentMethod.length > 100)
        errors.paymentMethod = true;
      if (!EMAIL_RE.test(v.email) || v.email.length > 254) errors.email = true;
      if (v.message.length < 10 || v.message.length > 5000)
        errors.message = true;
      if (!v.firstName || v.firstName.length > 100) errors.firstName = true;

      for (var k in fields) {
        setInvalid(fields[k], !!errors[k]);
      }
      return { values: v, errors: errors };
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearNotice();
      var result = validate();
      var errs = Object.keys(result.errors);
      if (errs.length) {
        var firstInvalid = form.querySelector(
          ".dispute-field.is-invalid input, .dispute-field.is-invalid select, .dispute-field.is-invalid textarea",
        );
        if (firstInvalid) firstInvalid.focus();
        showNotice(
          "error",
          "Please fix the highlighted fields and try again.",
        );
        return;
      }
      setSending(true);
      fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(result.values),
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              return { status: res.status, data: data };
            });
        })
        .then(function (r) {
          if (r.status >= 200 && r.status < 300 && r.data && r.data.ok) {
            setSending(false);
            goToStep(3);
            return;
          }
          setSending(false);
          var msg =
            r.data && r.data.error
              ? r.data.error
              : "Something went wrong. Please email help@deepdivesupplements.com directly.";
          showNotice("error", msg);
        })
        .catch(function () {
          setSending(false);
          showNotice(
            "error",
            "Network error. Please check your connection and try again.",
          );
        });
    });

    var tooltipTriggers = root.querySelectorAll(".dispute-tooltip__trigger");
    for (var t = 0; t < tooltipTriggers.length; t++) {
      tooltipTriggers[t].addEventListener("click", function (ev) {
        ev.preventDefault();
        var wrap = ev.currentTarget.closest(".dispute-tooltip");
        if (!wrap) return;
        var wasOpen = wrap.classList.contains("is-open");
        var allWraps = root.querySelectorAll(".dispute-tooltip.is-open");
        for (var a = 0; a < allWraps.length; a++)
          allWraps[a].classList.remove("is-open");
        if (!wasOpen) wrap.classList.add("is-open");
      });
    }
  }

  function bindGlobalClick() {
    if (globalClickBound) return;
    globalClickBound = true;
    document.addEventListener("click", function (ev) {
      if (!ev.target.closest || !ev.target.closest(".dispute-tooltip")) {
        var open = document.querySelectorAll(".dispute-tooltip.is-open");
        for (var a = 0; a < open.length; a++)
          open[a].classList.remove("is-open");
      }
    });
  }

  function boot() {
    var roots = document.querySelectorAll(".dd-dispute");
    if (!roots.length) return;
    bindGlobalClick();
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
